// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AtHC","label":"styles_label__1MYXU"};